import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getRecentTransaction } from '../../../feature/dashboard/DashboardSlice';

const cols = ['TYPE', 'DAYCARE', 'PLAN', 'AMOUNT', 'DATE', 'STATUS'];

function RecentTransactions({ month, year }) {
    const dispatch = useDispatch();
    const { recentTransaction } = useSelector((state) => state.dashboards);

    useEffect(() => {
        dispatch(getRecentTransaction({ month, year }));
    }, [dispatch, month, year]);

    const rows = Array.isArray(recentTransaction)
        ? recentTransaction.map((t) => ({
              type: t.type || 'Payment',
              typeBg: '#eef2ff',
              typeColor: '#6366f1',
              daycare: t.daycareName,
              plan: t.plan,
              amount: `$${t.amount}`,
              date: t.date,
              status: t.status,
              statusBg:
                  t.status === 'Completed' || t.status === 'Paid'
                      ? '#f0fdf4'
                      : '#fffbeb',
              statusColor:
                  t.status === 'Completed' || t.status === 'Paid'
                      ? '#22c55e'
                      : '#f59e0b',
          }))
        : [];

    return (
        <div
            style={{
                background: '#fff',
                borderRadius: 12,
                padding: '20px 24px',
                border: '1px solid #f0f0f0',
                boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                minHeight: 320,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 12,
                }}
            >
                <div>
                    <div
                        style={{
                            fontSize: 17,
                            fontWeight: 700,
                            color: '#111',
                        }}
                    >
                        Recent Transactions
                    </div>
                    <div
                        style={{
                            fontSize: 12,
                            color: '#aaa',
                            marginTop: 2,
                        }}
                    >
                        Latest payments & subscription renewals
                    </div>
                </div>

                <span
                    style={{
                        fontSize: 13,
                        color: '#6366f1',
                        cursor: 'pointer',
                        fontWeight: 500,
                    }}
                >
                    View all
                </span>
            </div>

            {rows.length === 0 ? (
                <div
                    style={{
                        flex: 1,
                        minHeight: 240,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        color: '#bbb',
                    }}
                >
                    <div style={{ fontSize: 32, marginBottom: 8 }}>💳</div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>
                        No transactions for this period
                    </div>
                </div>
            ) : (
                <div
                    style={{
                        flex: 1,
                        minHeight: 300,
                        overflowY: 'auto',
                        maxHeight:"40vh",
                    }}
                >
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                        }}
                    >
                        <thead>
                            <tr>
                                {cols.map((c) => (
                                    <th
                                        key={c}
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: '#fff',
                                            zIndex: 2,
                                            textAlign: 'left',
                                            fontSize: 11,
                                            color: '#aaa',
                                            fontWeight: 600,
                                            padding: '10px 8px',
                                            letterSpacing: 0.5,
                                            borderBottom:
                                                '1px solid #f0f0f0',
                                        }}
                                    >
                                        {c}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {rows.map((r, i) => (
                                <tr
                                    key={i}
                                    style={{
                                        borderBottom:
                                            '1px solid #fafafa',
                                    }}
                                >
                                    <td style={{ padding: '11px 8px' }}>
                                        <span
                                            style={{
                                                background: r.typeBg,
                                                color: r.typeColor,
                                                borderRadius: 6,
                                                padding: '3px 10px',
                                                fontSize: 12,
                                                fontWeight: 600,
                                            }}
                                        >
                                            {r.type}
                                        </span>
                                    </td>

                                    <td
                                        style={{
                                            padding: '11px 8px',
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: '#111',
                                        }}
                                    >
                                        {r.daycare}
                                    </td>

                                    <td
                                        style={{
                                            padding: '11px 8px',
                                            fontSize: 13,
                                            color: '#555',
                                        }}
                                    >
                                        {r.plan}
                                    </td>

                                    <td
                                        style={{
                                            padding: '11px 8px',
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: '#111',
                                        }}
                                    >
                                        {r.amount}
                                    </td>

                                    <td
                                        style={{
                                            padding: '11px 8px',
                                            fontSize: 12,
                                            color: '#888',
                                        }}
                                    >
                                        {r.date}
                                    </td>

                                    <td style={{ padding: '11px 8px' }}>
                                        <span
                                            style={{
                                                background: r.statusBg,
                                                color: r.statusColor,
                                                borderRadius: 20,
                                                padding: '3px 10px',
                                                fontSize: 12,
                                                fontWeight: 600,
                                            }}
                                        >
                                            {r.status}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default RecentTransactions;